const stringLiteralArray = <L extends string>(arr: L[]) => arr;

export const ScoreCategories = stringLiteralArray(['extreme', 'high', 'medium', 'low']);

export type ScoreCategoryType = (typeof ScoreCategories)[number];
